import { create } from 'zustand'

type ModerationState = {
    dateModerationInit: string | null
    dateModerationFinish: string | null
    moderation: boolean
    setModeration: (init: string, finish: string, moderation: boolean) => void
    isUserBlocked: () => boolean
}

export const useModerationPeriodStore = create<ModerationState>((set, get) => ({
    dateModerationInit: null,
    dateModerationFinish: null,
    moderation: false,
    setModeration: (init, finish, moderation) => {
        set({
            dateModerationInit: init,
            dateModerationFinish: finish,
            moderation: moderation,
        })
    },
    isUserBlocked: () => {
        const { dateModerationInit, dateModerationFinish, moderation } = get()
        if (!moderation || !dateModerationInit || !dateModerationFinish) {
            return false
        }
        const now = new Date()
        const initDate = new Date(dateModerationInit)
        const finishDate = new Date(dateModerationFinish)

        return now >= initDate && now <= finishDate
    },
}))
